import useUserNotifications from '@/services/Notification/NotificationCenter/hooks/useUserNotifications'
import css from './recentNotificationsWidget.module.css'
import NotificationsList from '@/services/Notification/NotificationCenter/components/NotificationsList'
import useObserveElementsByIntersection from '@/services/Notification/NotificationCenter/hooks/useObserveElementsByIntersection'
import { INotification } from '@/services/Notification/notifications.types'
import { useEffect, useRef } from 'react'
import NotificationCenterCardSkeleton from '@/services/Notification/NotificationCenter/components/NotificationCenterCardSkeleton'
import EmptyPlaceholder from '@/shared/Common/EmptyPlaceholder'

const RecentNotificationsWidget = () => {
  const observingElements = useRef<{ element: HTMLElement; id: INotification['id']; seen: INotification['seen'] }[]>([])
  const ctrl = useUserNotifications()

  useEffect(() => {
    ctrl.updateNotifications()

    return () => {
      ctrl.sendViewed()
    }
  }, [])

  useObserveElementsByIntersection({
    elements: observingElements.current,
    refreshKey: ctrl.nextNotificationPageId,
    active: ctrl.notifications.length > 0,
    handleViewedNotification: (id) => ctrl.viewedRef.current.add(id),
    viewedNotifications: ctrl.viewedRef.current,
  })

  const renderContent = () => {
    if (ctrl.notificationsLoading && !ctrl.notifications.length) {
      return (
        <div className="width100">
          <NotificationCenterCardSkeleton wrapperStyle={{ padding: 0 }} />
        </div>
      )
    }

    if (!ctrl.notifications.length) {
      return (
        <div style={{ marginTop: '80px' }}>
          <EmptyPlaceholder inscription={`У вас пока пока нет\nни одного уведомления`} />
        </div>
      )
    }

    return (
      <NotificationsList
        loadMore={ctrl.loadNotifications}
        notifications={ctrl.notifications}
        isMore={ctrl.nextNotificationPageId !== null}
        onObserveCard={(el: HTMLElement | null, index: number, notification: INotification) =>
          (observingElements.current[index] = { element: el, id: notification.id, seen: notification.seen })
        }
      />
    )
  }

  return (
    <div className={css.wrapper}>
      <h2 style={{ padding: '6px 20px' }} className="text-heading-4">
        Последние уведомления
      </h2>
      <div className={css.notificationsWrapper}>{renderContent()}</div>
    </div>
  )
}

export default RecentNotificationsWidget
